'use strict';

/**
 *
 * @name: nnCompileWithCollapse
 *
 */

import {passPropToAddonYouTube, passPropToAddonSlideshow} from './compile-helpers'

function convertNodeListToHTML (nodeList) {
  let html = ''
  nodeList.forEach(node => {
    html += node.outerHTML
  })
  return html
}

function isMedia (node) {
  if (!node.innerHTML) return false
  if (node.outerHTML.indexOf('<img') > -1 || node.className.indexOf('nowness-addon') > -1) return true
}

function CompileDirective($compile) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    scope: true,
    link: function(scope, element, attr) {
      const {
        content,
        visibleNodesNum = 2,
        isInitiallyCollapsed,
      } = attr

      if (!content) return

      const originalHtml = content
      const newHtml = passPropToAddonYouTube(passPropToAddonSlideshow(originalHtml, 'post'), 'post')
      element.html(newHtml);

      // setup collapse
      const el = element[0]
      const visiblePart = []
      const collapsedPart = []

      el.childNodes.forEach((node, i) => {
        if(!node.innerText && !isMedia(node)) return

        if (i < visibleNodesNum) {
          if (isMedia(node)) {
            collapsedPart.push(node)
          } else {
            visiblePart.push(node)
          }
        } else {
          collapsedPart.push(node)
        }
      })
      scope.visiblePartHTML = convertNodeListToHTML(visiblePart)
      scope.collapsedPartHTML = convertNodeListToHTML(collapsedPart)

      element.html(`
        <nn-roll-out-section visible-part="visiblePartHTML" is-collapse-part="!!collapsedPartHTML" is-initially-collapsed=${isInitiallyCollapsed}>${scope.collapsedPartHTML}</nn-roll-out-section>
      `)

      const contents = element.contents()
      $compile(contents)(scope);
    }
  };
}

export default CompileDirective;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-compile-with-collapse.directive.js